import { lazy } from 'react';

const ProductCreate = lazy(() => import('./ProductCreate'));

export default ProductCreate;
